/* eslint-disable no-useless-escape */
import * as yup from 'yup';
import { AnySchema } from 'yup';
import Lazy from 'yup/lib/Lazy';
import Reference from 'yup/lib/Reference';

import { IErrorObject } from '../../../utils/validator';

export enum NOTIFICATION_FIELD_KEYS {
  TITLE = 'title',
  DESCRIPTION = 'description',
  URL = 'url',
  PLATFORMS = 'platforms',
  SEND_AT = 'sendAt',
  TARGET_TYPE = 'targetType',
  TARGET_SEGMENT_TYPE = 'targetSegmentType',
  TARGETS = 'targets',
  FILE_NAME = 'fileName',
}

export interface INotificationFormValues {
  title: string | null;
  description: string | null;
  url: string | null;
  platforms: string[];
  sendAt: Date | null;
  targetType: string | null;
  targetSegmentType?: string | null;
  targets?: string[];
  fileName?: string | null;
}

export interface IErrorsNotification {
  title?: IErrorObject;
  description?: IErrorObject;
  url?: IErrorObject;
  platforms?: IErrorObject;
  sendAt?: IErrorObject;
  targetType?: IErrorObject;
  targets?: IErrorObject;
  targetSegmentType?: IErrorObject;
  fileName?: IErrorObject;
}

export type INotificationFields = keyof IErrorsNotification;

const NotificationFormObj: { [key in INotificationFields]: AnySchema<unknown, unknown, unknown> | Reference<unknown> | Lazy<never, unknown> } = {
  title: yup.string().nullable().required('Title is required').trim(),
  description: yup.string().nullable().required('Description is required').trim(),
  url: yup.string().nullable().trim().url('Please enter a valid URL including https://'),
  platforms: yup.array().of(yup.string()).min(1, 'Select at least 1 platform').required('Select at least 1 platform'),
  sendAt: yup.date().nullable().required('Send At is required'),
  targetType: yup.string().nullable().required('Target Type is required').trim(),
  targetSegmentType: yup
    .string()
    .nullable()
    .when('targetType', {
      is: (val: string) => val === 'specific-user',
      then: (schema) => schema.required('Target Segment Type is required').trim(),
      otherwise: (schema) => schema.notRequired().nullable().trim(),
    }),
  targets: yup.array().of(yup.string().trim()).default(['']),
  // targets: yup.array().of(yup.string()).min(1, 'Select at least 1 target').required('Select at least 1 target'),
  fileName: yup.string().nullable().trim(),
};

export default NotificationFormObj;
